import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Post-login landing route, mounted under the AppLayout shell. The header
// title/subtitle come from this route's meta. `greetUser` tells the shell to
// personalise the title with the signed-in seller's name; `title` is the
// fallback shown until the profile query resolves.
export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: routes.DASHBOARD,
    name: 'DASHBOARD',
    component: () => import('./DashboardPage.vue'),
    meta: {
      requiresAuth: true,
      greetUser: true,
      title: 'Welcome',
      subtitle: "Let's turn your property into capital.",
    },
  },
]
